import React, { useCallback, useMemo, useState, useEffect, useLayoutEffect, useRef } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { hideModal, showModal } from '../../../../actions/modal';
import Modal from '../../../../components/common/Modal';
import GstInfoSideModal from './GstInfoSideModal/GstInfoSideModal';
import './GSTInfoModal/index.pcss';
import styles from './index.pcss';
import classNames from 'classnames/bind';
import properties from '../../../../modules/ajio-util/properties';
import GSTInvoice from '../../mobile/GSTSectionODP/GSTInvoice/index';
import { validateGSTUAAS } from '../../../../cart/actions/gst';
import { segmentEventPush } from '../../../../modules/ga/GTMdatalayer';
import ReactDOMServer from 'react-dom/server';
import {
  getGSTODPConfig,
  getGSTCommonConfig
} from '../../../../refresh/selectors/featureFlagsSelector';
import { getLuxeFlags } from '../../../../Flags/selectors';
import { getCurrentStore } from '../../../../refresh/selectors/metaData';

const cx = classNames.bind(styles);
const imageBaseUrl = properties.getProperty('imageBaseUrl');

const GSTInfo = ({
  cancelRequest = false,
  returnRequest = false,
  isThankYouPage = false,
  orderGstDetails = {},
  productId = [],
  showModal,
  hideModal,
  orderLevelDetail,
  validateGSTUAAS,
  gstODPConfig,
  gstCommonConfig,
  orderPaymentCode = '',
  luxe = false,
  orderData = {}
}) => {
  const [isGstExpired, setIsGstExpired] = useState(false);
  const orderDataForProduct = isThankYouPage ? orderData : orderLevelDetail;
  const effectiveOrderLevelDetail = useMemo(() => {
    if (returnRequest) {
      try {
        const localStorageGstDetails = localStorage.getItem('gstDetailsStorage');
        if (localStorageGstDetails) {
          const parsedData = JSON.parse(localStorageGstDetails);
          return parsedData || orderDataForProduct;
        }
      } catch (error) {
        console.error('Error parsing orderResponse from localStorage:', error);
      }
    }
    return orderDataForProduct;
  }, [returnRequest, orderDataForProduct]);

  let gstDetails = effectiveOrderLevelDetail?.gstDetails || {};
  if (isThankYouPage && orderGstDetails?.gstNumber) {
    gstDetails = orderGstDetails;
  }
  const { gstNumber = '', businessName = '', address = {} } = gstDetails;

  const formattedAddress = address?.formattedAddress || '';
  const {
    cancelledEntries = [],
    confirmedEntries = [],
    consignmentsData = [],
    code,
    paymentMode = '',
    entries,
    paymentSuccessful,
    isExchangeOrder
  } = effectiveOrderLevelDetail;
  const isDeliveredEntriesEmpty = consignmentsData.every(
    shipment => !shipment.entries || shipment.entries.length === 0
  );

  const getTextContent = node => {
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (!node) return '';
    if (React.isValidElement(node)) {
      return ReactDOMServer.renderToStaticMarkup(node)
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    if (Array.isArray(node)) {
      return node
        .map(getTextContent)
        .join(' ')
        .trim();
    }
    return '';
  };
  useEffect(() => {
    if (returnRequest || cancelRequest) {
      const gstDetails = { gstNumber, businessName };
        validateGSTUAAS(gstDetails, res => {
          if (res.status === 'ERROR' && res?.active === false) {
            setIsGstExpired(() => {
              callSegment(true);
              return true;
            });
          } else {
            setIsGstExpired(() => {
              callSegment(false);
              return false;
            });
          }
        });
    } else {
      const cancelledExpired = cancelledEntries?.some(item => item?.gstDetails?.valid === false);
      const returnExpired = consignmentsData?.some(consignment =>
        consignment?.returnRequests?.some(el => el?.gstDetails?.valid === false)
      );
      setIsGstExpired(() => {
        callSegment(cancelledExpired || returnExpired);
        return cancelledExpired || returnExpired;
      });
    }
  }, []);

  const screenName = useMemo(() => {
    return returnRequest
      ? 'Return Request Submit Screen'
      : cancelRequest
      ? 'Order Cancellation Screen'
      : 'Order item details screen';
  }, [returnRequest, cancelRequest]);

  const { productIds, productStatuses } = useMemo(() => {

    const productIds = [];
    const productStatuses = [];

    consignmentsData.forEach(el => {
      const { entries: consignedEntries = [], returnRequests = [], shipmentStatus = '' } = el;

      consignedEntries.forEach(ce => {
        const { orderEntry: item = {} } = ce;
        productIds.push(item?.product?.code);
        productStatuses.push(String(shipmentStatus).toUpperCase());
      });

      returnRequests.forEach(rr => {
        const { returnEntries = [], returnCancelledEntries = [], returnStatus = '' } = rr;
        [...returnEntries, ...returnCancelledEntries].forEach(re => {
          const { entry: item = {} } = re || {};
          productIds.push(item?.product?.code);
          productStatuses.push(String(returnStatus).toUpperCase());
        });
      });
    });

    confirmedEntries.forEach(cfe => {
      const { entry: item = {} } = cfe;
      let orderStatus = 'Confirmed';
      if (paymentSuccessful === false) orderStatus = 'Payment Unsuccessful';
      if (isExchangeOrder === true) orderStatus = 'Exchange Confirmed';

      productIds.push(item?.product?.code);
      productStatuses.push(orderStatus.toUpperCase());
    });

    cancelledEntries.forEach(cce => {
      const { entry: item = {} } = cce;
      productIds.push(item?.product?.code);
      productStatuses.push(item?.newEntryStatus);
    });

    return { productIds, productStatuses };
  }, [
    returnRequest,
    cancelRequest,
    productId,
    consignmentsData,
    confirmedEntries,
    cancelledEntries,
    paymentSuccessful,
    isExchangeOrder
  ]);

  const callSegment = isExp => {
    const message = getTextContent(warningContent(isExp)?.text);
    const session_id = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('sessionId') : '';

    if (message) {
      segmentEventPush({
        event: 'GST Component Viewed',
        page_name: screenName,
        display_message: message,
        order_id: code,
        products: productIds.map(x => ({ product_id: x })),
        order_status: productStatuses.join(','),
        ...((returnRequest || cancelRequest) && {
          previous_screen_name: returnRequest
            ? 'Return size & reason selection screen'
            : 'order item details screen'
        })
      });
    }
  };

  const handleMoreInfoClick = useCallback(() => {
    segmentEventPush({
      event: 'GST More info Clicked',
      page_name: screenName,
      order_id: code,
      cart_id: code,
      payment_type: orderPaymentCode || paymentMode,
      ...(!isThankYouPage && {
        products: productIds.map(x => ({ product_id: x })),
        order_status: productStatuses.join(',')
      }),
      ...((returnRequest || cancelRequest || isThankYouPage) && {
        previous_screen_name: returnRequest
          ? 'Return size & reason selection screen'
          : 'order item details screen'
      })
    });

    showModal('gst-details');
  }, [showModal, screenName, returnRequest, cancelRequest]);

  const handleMoreInfoAccordionClick = useCallback(
    accordionTitle => {
      segmentEventPush({
        event: 'More Info Accordion Clicked',
        page_name: screenName,
        screen_name: 'GST More Info Screen',
        order_id: code,
        cart_id: code,
        payment_type: orderPaymentCode || paymentMode,
        ...(!isThankYouPage && {
          products: productIds.map(x => ({ product_id: x })),
          order_status: productStatuses.join(',')
        }),
        ...(accordionTitle && { accordion_title: accordionTitle }),
        ...((returnRequest || cancelRequest || isThankYouPage) && {
          previous_screen_name: returnRequest
            ? 'Return size & reason selection screen'
            : 'order item details screen'
        })
      });
    },
    [screenName, code, productIds, productStatuses, returnRequest, cancelRequest, isThankYouPage]
  );

  const moreInfoTrackingPayload = useMemo(
    () => ({
      page_name: screenName,
      order_id: code,
      cart_id: code,
      payment_type: orderPaymentCode || paymentMode,
      ...(!isThankYouPage && {
        products: productIds.map(x => ({ product_id: x })),
        order_status: productStatuses.join(',')
      }),
      ...((returnRequest || cancelRequest || isThankYouPage) && {
        previous_screen_name: returnRequest
          ? 'Return size & reason selection screen'
          : 'order item details screen'
      })
    }),
    [
      screenName,
      code,
      orderPaymentCode,
      paymentMode,
      productIds,
      productStatuses,
      returnRequest,
      cancelRequest,
      isThankYouPage
    ]
  );

  const handleModalClose = useCallback(() => {
    hideModal('gst-details');
  }, [hideModal]);

  const handleDownloadInvoiceClose = useCallback(() => {
    hideModal('download-invoice-modal');
  }, [hideModal]);

  const handleDownloadInvoiceClick = useCallback(() => {
    hideModal('gst-details');

    segmentEventPush({
      event: 'Download Invoice Clicked',
      screen_name: 'GST More Info Screen',
      page_name: screenName,
      order_id: code,
      cart_id: code,
      payment_type: orderPaymentCode || paymentMode,
      products: productIds.map(x => ({ product_id: x })),
      order_status: productStatuses.join(','),
      ...((returnRequest || cancelRequest || isThankYouPage) && {
        previous_screen_name: returnRequest
          ? 'Return size & reason selection screen'
          : 'order item details screen'
      })
    });
    showModal('download-invoice-modal');
  }, [hideModal, showModal]);

  const sectionStyle = useMemo(
    () =>
      isThankYouPage
        ? {
            padding: '15px',
            marginTop: '24px',
            marginBottom: '24px',
            border: '1px solid #e8e8e8',
            backgroundColor: '#FAFAFA'
          }
        : {
            border: cancelRequest || returnRequest ? '1px solid #F0F0F0' : 'none',
            padding: cancelRequest || returnRequest ? '12px 16px' : '16px 24px',
            width: cancelRequest || returnRequest ? '400px' : '100%',
            marginTop: cancelRequest ? '12px' : '8px'
          },
    [cancelRequest, returnRequest, isThankYouPage]
  );

  const titleStyle = useMemo(
    () =>
      isThankYouPage
        ? {
            fontSize: '14px'
          }
        : {
            fontSize: cancelRequest || returnRequest ? '14px' : '18px'
          },
    [cancelRequest, returnRequest, isThankYouPage]
  );

  const warningContent = isExpired => {
    const isGSTExp = isExpired || isGstExpired;
    if (isGSTExp) {
      return {
        className: cx('warning-box', 'gst-err'),
        text: (
          <div className={cx('expired-content')}>
            <img
              src={`${imageBaseUrl}/static/img/gst-error-icon.svg`}
              alt="Information icon"
              className={cx('icon')}
            />
            {returnRequest ? (
              <div>{gstODPConfig.gstExpiredError}</div>
            ) : (confirmedEntries.length === 0 && consignmentsData.length === 0) ||
              cancelRequest ? (
              <div>{gstODPConfig.cancelError}</div>
            ) : (
              <div>{gstODPConfig.gstExpiredError}</div>
            )}
          </div>
        )
      };
    }
    if (cancelRequest) {
      return {
        className: cx('warning-box', 'gst-err'),
        text: (
          <div className={cx('expired-content')}>
            <img
              src={`${imageBaseUrl}/static/img/gst-error-icon.svg`}
              alt="Information icon"
              className={cx('icon')}
            />
            <div>{gstODPConfig.cancelError}</div>
          </div>
        )
      };
    }
    if (returnRequest) {
      return {
        className: cx('warning-box'),
        text: gstODPConfig.returnNote
      };
    }
    // If order has only return requests/items
    if (
      cancelledEntries.length === 0 &&
      confirmedEntries.length === 0 &&
      consignmentsData.every(shipment => !shipment.entries || shipment.entries.length === 0)
    ) {
      if (
        consignmentsData.every(consignment =>
          consignment?.returnRequests?.every(
            returnRequest =>
              returnRequest?.returnType === 'RTO' || returnRequest?.returnStatus === 'Refunded'
          )
        )
      ) {
        return {
          className: cx('warning-box'),
          text: null
        };
      }
      return {
        className: cx('warning-box'),
        text: gstODPConfig.returnNote
      };
    }
    // If order has only cancelled items
    if (confirmedEntries.length === 0 && consignmentsData.length === 0) {
      return {
        className: cx('warning-box', 'gst-err'),
        text: (
          <div className={cx('expired-content')}>
            <img
              src={`${imageBaseUrl}/static/img/gst-error-icon.svg`}
              alt="Information icon"
              className={cx('icon')}
            />
            <div>{gstODPConfig.cancelError}</div>
          </div>
        )
      };
    }
    return {
      className: cx('warning-box'),
      text: (
        <>
          {gstODPConfig.generalMessage.map(msg => {
            return <div key={msg}>{msg}</div>;
          })}
        </>
      )
    };
    // }
    return;
  };

  const renderInBody = modalNode => {
    if (typeof document === 'undefined' || !document.body) return modalNode;
    return ReactDOM.createPortal(modalNode, document.body);
  };

  return (
    <div
      className={cx(
        luxe ? 'luxe-gst-info-section' : 'gst-info-section',
        isThankYouPage && 'thank-you-gst-info-section'
      )}
      style={sectionStyle}
    >
      <section className={cx('gst-header')}>
        <span className={cx('gst-title')} style={titleStyle} role='heading' aria-level={2}>
          GST Number
        </span>
        <span
          className={cx('more-info-link')}
          onClick={handleMoreInfoClick}
          tabIndex={0}
          role="button"
          aria-label="More information about GST"
        >
          More info
        </span>
      </section>
      <div className={cx('gst-number-row')}>
        <div className={cx('gst-number')}>
          <span aria-hidden="true">{gstNumber}</span>
          <span className="sr-only">
            {gstNumber?.split('').join(', ')}
          </span>
        </div>
        {isGstExpired && (
          <div className={cx('err-tag')}>
            <span className={cx('err-tag-text')}>{gstCommonConfig?.gstExpiredTag}</span>
          </div>
        )}
      </div>
      <div className={cx('company-name')}>{businessName}</div>
      {warningContent()?.text && (
        <div className={warningContent()?.className}>
          <span className={cx('warning-text')}>{warningContent()?.text}</span>
        </div>
      )}
      {renderInBody(
        <Modal
          show
          ariaLabel="GST Details & FAQ's"
          name="gst-details"
          className={luxe ? 'luxe-gst-info-side-modal' : 'gst-info-side-modal'}
          onClose={handleModalClose}
        >
          <GstInfoSideModal
            gstNumber={gstNumber}
            businessName={businessName}
            billingAddressLabel={gstCommonConfig.billingAddressLabel}
            gstinLabel={gstCommonConfig.gstinLabel}
            address={formattedAddress}
            handleDownloadInvoiceClick={handleDownloadInvoiceClick}
            handleAccordionClick={handleMoreInfoAccordionClick}
            isDeliveredEntriesEmpty={isDeliveredEntriesEmpty}
            isThankYouPage={isThankYouPage}
            orderData={effectiveOrderLevelDetail}
            moreInfoTrackingPayload={moreInfoTrackingPayload}
            luxe={luxe}
          />
        </Modal>
      )}
        <Modal
          show
          name="download-invoice-modal"
          className={luxe ? cx('luxe-gst-info') : cx('gst-info')}
          onClose={handleModalClose}
        >
          <GSTInvoice
            onClose={handleDownloadInvoiceClose}
            luxe={luxe}
            orderLevelDetail={effectiveOrderLevelDetail}
          />
        </Modal>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    ordersData: { orderLevelDetail: { orderResponse = {} } = {} } = {},
    flags = {},
    order: { gstDetails = {}, paymentCode = '' } = {}
  } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const luxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  return {
    orderLevelDetail: orderResponse,
    gstODPConfig: getGSTODPConfig(state),
    gstCommonConfig: getGSTCommonConfig(state),
    orderGstDetails: gstDetails,
    orderPaymentCode: paymentCode,
    luxe,
    orderData: state?.order || {}
  };
};

const mapDispatchToProps = {
  showModal,
  hideModal,
  validateGSTUAAS
};

export default connect(mapStateToProps, mapDispatchToProps)(GSTInfo);
